// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"88a118e6","151":"7b7644b6","223":"3d01d8e3","298":"1b1f3b32","368":"97faffe1","459":"cbfb100a","896":"fb334753","984":"17eb8cdb"}[chunkId] + ".chunk.js";
};